// Game Properties
import { AppEvents } from '../core/AppStatus';
import { emit } from '../utils/GlobalEventDispatcher';

// Event names
const GameEvents = {
	GAME_UI_OVERLAP: 'game_ui_overlap'
};

export const LobbyEvents = {
	OPEN_LOBBY: 'open_lobby',
	INIT_EXT_WIDGETS: 'init_ext_widgets',
	DISABLE_EXT_WIDGETS: 'disable_ext_widgets',
	ENABLE_EXT_WIDGETS: 'enable_ext_widgets',
	GAME_UI_OVERLAP: 'game_ui_overlap'
};

const handleOverlapEvent = (isOverlapped: boolean) => {
	emit(AppEvents.APP_UI_OVERLAP, isOverlapped);
};

const gameEventsHandler = (eventName: string, targetName: string, context: any) => {
	switch (eventName) {
		case GameEvents.GAME_UI_OVERLAP:
			handleOverlapEvent(context);

			break;
	}
};

const postMessagesHandler = (event: any) => {
	const cmd = event.data;

	switch (cmd.name) {
		case LobbyEvents.GAME_UI_OVERLAP:
			handleOverlapEvent(cmd?.isOverlapped);

			break;

		case LobbyEvents.INIT_EXT_WIDGETS:
			emit(AppEvents.APP_RUN);

			break;

		case LobbyEvents.DISABLE_EXT_WIDGETS:
			emit(AppEvents.APP_DISABLE);

			break;

		case LobbyEvents.ENABLE_EXT_WIDGETS:
			emit(AppEvents.APP_ENABLE);

			break;
	}
};

export const setupExternalEvents = () => {
	// @ts-ignore
	if (!window.trackGameEventListeners) {
		// @ts-ignore
		window.trackGameEventListeners = [];
	}

	// @ts-ignore
	window.trackGameEventListeners.push(gameEventsHandler);
	window.addEventListener('message', postMessagesHandler);

	return {
		cleanup: () => {
			window.removeEventListener('message', postMessagesHandler);
			// @ts-ignore
			const index = window.trackGameEventListeners.indexOf(gameEventsHandler);
			if (index > -1) {
				// @ts-ignore
				window.trackGameEventListeners.splice(index, 1);
			}
		}
	};
};
